import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { setPageTitle } from 'actions/header';
import { translate } from '@haldor/ui';
import { getSchoolType } from 'helpers/localstorage';
import { PRESCHOOL } from 'constants/schoolTypes';
import MyPosts from './Sections/MyPosts';
import MyPlans from './Sections/MyPlans';
import MyTasks from './Sections/MyTasks';
import LoadingCards from 'components/Presentation/Cards/LoadingCards';
import { InView } from 'react-intersection-observer';
var Overview = /*#__PURE__*/function (_Component) {
  function Overview() {
    _classCallCheck(this, Overview);
    return _callSuper(this, Overview, arguments);
  }
  _inherits(Overview, _Component);
  return _createClass(Overview, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.setPageTitle(this.props.translate('Home'));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, this.props.activeStudent != null && this.props.activeStudent.services.news ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(MyPosts, {
        limit: 3
      })) : null, this.props.activeStudent != null && this.props.activeStudent.services.plans ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(InView, {
        as: "div",
        delay: 550,
        triggerOnce: true
      }, function (_ref) {
        var inView = _ref.inView,
          ref = _ref.ref,
          entry = _ref.entry;
        return /*#__PURE__*/React.createElement("div", {
          className: "section",
          ref: ref
        }, inView ? /*#__PURE__*/React.createElement(MyPlans, {
          dateRestriction: true,
          overview: true
        }) : /*#__PURE__*/React.createElement(LoadingCards, {
          count: 1
        }));
      })) : null, getSchoolType(this.props.activeStudent) != PRESCHOOL ? /*#__PURE__*/React.createElement("div", {
        className: "section",
        style: {
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(InView, {
        as: "div",
        delay: 550,
        triggerOnce: true
      }, function (_ref2) {
        var inView = _ref2.inView,
          ref = _ref2.ref,
          entry = _ref2.entry;
        return /*#__PURE__*/React.createElement("div", {
          className: "section",
          ref: ref
        }, inView ? /*#__PURE__*/React.createElement(MyTasks, {
          limit: 9,
          overview: true
        }) : /*#__PURE__*/React.createElement(LoadingCards, {
          count: 1
        }));
      })) : null);
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.User.activeStudent,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  setPageTitle: setPageTitle
})(Overview);